import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex';
import * as usertypes from '@account/store/types';

// component
import SearchForm from '@home/components/Search/SearchForm.vue'
import SearchResultBoard from '@home/components/Search/SearchResultBoard.vue'
import SearchResultOrg from '@home/components/Search/SearchResultOrg.vue'
import { createEventBus } from '@/modules/@appbase/util';

@Component({
    components: {
        SearchForm,
        SearchResultBoard,
        SearchResultOrg
    },
    computed: mapGetters({
        userCurrent: usertypes.CURRENT
    })
})
export default class SearchContainer extends Vue {
    userCurrent!: account.TCurrent;
    searchText: string = ''
    searchBaseUrl : string = ""

    ifrmSearch: HTMLIFrameElement | null= null;
   
    created(){          
        createEventBus(window, 'portal-goBoardDetail', this.boardDetailHandler);
        
        let reqSearch = (this.$route.query.searchText ? this.$route.query.searchText.toString() : '')        
        this.searchText = reqSearch;
        this.searchBaseUrl = `${window.location.origin}/srch`
    }  

    fnTotalSearch(text: string) {
       this.searchText = text;
    }

    boardDetailHandler(data: { boardId: number, articleId: number, volumeName: string }) {
        this.$router.push({
            path: 'modal/read',
            append: true,
            query: {
                SYSID: data.boardId.toString(),
                ARTICLEID: data.articleId.toString()           
            }
        })
    }
}